module.exports = __webpack_public_path__ + "img/bg_plan_type_play.6ab4ce2a.jpg";